const validator = {};

const NUM = /^[0-9]+$/;
const KOR = /^[가-힣]+$/;
const KOR_BRACKET = /^[가-힣()]+$/;
const ALPHA = /^[a-zA-z]+$/;
const ALPHA_NUM = /^[a-zA-z0-9]+$/;
const ALPHA_NUM_BRACKET_HYPHEN = /^[a-zA-z0-9()-]+$/;
const ALPHA_KOR_NUM = /^[a-zA-z가-힣0-9]+$/;
const TEL = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/;
const PHONE = /^01[0-9]-[0-9]{3,4}-[0-9]{4}$/;

var errors = {};

const checkByRegex = function(field, text, regex, errorMessage) {
    if (!regex.test(text)) {
        errors[field] = errorMessage;
    }
};

validator.clear = function() {
    errors = {};
};

validator.hasErrors = function() {
    return Object.keys(errors).length > 0;
};

validator.hasError = function(field) {
    return field in errors;
};

validator.getError = function(field) {
    return field in errors ? errors[field] : "";
};

validator.setError = function(field, errorMessage) {
    if (Boolean(errorMessage)) {
        errors[field] = errorMessage;
    } else {
        delete errors[field];
    }
};

validator.isAllValidate = function() {
    return Object.keys(errors).length <= 0;
};

validator.updateVueIfError = function(vue) {
    if (this.hasErrors()) {
        vue.$forceUpdate();
    }
}

validator.checkEmpty = function(field, text) {
    if (!this.hasError(field) && !Boolean(text)) {
        errors[field] = "입력하세요";
    }
};

validator.checkLength = function(field, text, length) {
    if (!this.hasError(field)) {
        if (length > 0 && text.length > length) {
            errors[field] = length + "자 이내로 입력하세요";
        }
    }
};

validator.alphaNum = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, ALPHA_NUM, "공백없이 알파벳과 숫자만 입력하세요");
    }
};

validator.alphaNumBracketHyphen = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, ALPHA_NUM_BRACKET_HYPHEN, "공백없이 알파벳, 숫자, 괄호(), 하이픈(-)만 입력하세요");
    }
};

validator.alphaKorNum = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, ALPHA_KOR_NUM, "공백없이 알파벳, 한글, 숫자만 입력하세요");
    }
};

validator.kor = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, KOR, "공백없이 한글만 입력하세요");
    }
};

validator.korBracket = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, KOR_BRACKET, "공백없이 한글, 괄호()만 입력하세요");
    }
};

validator.tel = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, TEL, "000-000-0000 형식으로 입력하세요.");
    }
};

validator.phone = function(field, text) {
    if (!this.hasError(field)) {
        checkByRegex(field, text, PHONE, "010-0000-0000 형식으로 입력하세요");
    }
};

validator.replacePhone = function(text) {
    return (text) ? text.replace(/[\s\D-]/g, "")
        .replace(/([\d]{3})([\d])/, "$1-$2")
        .replace(/([\d]{3})-([\d]{3,4})([\d])/, "$1-$2-$3")
        .replace(/([\d]{3})-([\d]{3})(\d)-([\d]{2,4})(.*)/, "$1-$2-$3$4")
        .replace(/([\d]{3})-([\d]{3})-([\d])([\d]{4})/, "$1-$2$3-$4") : "";
};

validator.replaceAlphaNum = function(text) {
    return (text) ? text.replace(/[^a-zA-Z0-9]/g, "") : "";
};

validator.replaceAlphaNumUnderbar = function(text) {
    return (text) ? text.replace(/[\W]/g, "") : "";
};

validator.replaceAlphaKorNum = function(text) {
    return (text) ? text.replace(/[^a-zA-Z가-힣0-9]/g, "") : "";
};

validator.replaceAlphaKorNumBracket = function(text) {
    return (text) ? text.replace(/[^a-zA-Z가-힣0-9()]/g, "") : "";
};

validator.replaceAlphaKorNumSpecial = function(text) {
    return (text) ? text.replace(/[^a-zA-Z가-힣0-9.,()/_-]/g, "") : "";
};

validator.replaceKor = function(text) {
    return (text) ? text.replace(/[^가-힣]/g, "") : "";
};

validator.replaceKorNum = function(text) {
    return (text) ? text.replace(/[^가-힣0-9]/g, "") : "";
};

validator.replaceNum = function(text) {
    return (text) ? text.replace(/[^0-9]/g, "") : "";
};

validator.replaceNumDashBracket = function(text) {
    return (text) ? text.replace(/[^0-9()-]/g, "") : "";
};

validator.install = function (Vue) {
    Vue.prototype.$validator = validator;
};

export default validator;


// WEBPACK FOOTER //
// ./src/validator.js